import OfferResale from "./offer-resale";
export default OfferResale;